import { h } from "preact";
import { TABS } from "./constants";

export default function ({ pages, activeTab, translations }) {
  const style = activeTab === TABS.pages ? {} : { display: "none" };

  console.log("<->", pages);

  const items = pages?.map(({ title, url, content }) => (
    <a href={url} className="main-search__page-result">
      <h3 className="h5 main-search__page-result-title">{title}</h3>
      <div className="main-search__page-result-content">
        {content.split("\n").map((p) => (
          <p>{p}</p>
        ))}
      </div>
    </a>
  ));

  return (
    <div
      role="tabpanel"
      aria-labelledby={`search-tab-${TABS.pages}`}
      className="main-search__page-results-wrapper"
      style={style}
    >
      {!pages ? null : !pages.length ? (
        <div className="main-search__no-item-results">
          {translations.page_no_results}
        </div>
      ) : (
        <div className="main-search__page-results">{items}</div>
      )}
    </div>
  );
}
